<script setup lang="ts">
import type { PaginationPrevProps } from 'reka-ui';
import type { HTMLAttributes } from 'vue';
import { reactiveOmit } from '@vueuse/core';
import { ChevronLeftIcon } from 'lucide-vue-next';
import { PaginationPrev, useForwardProps } from 'reka-ui';
import { cn } from '@/lib/utils';
import { buttonVariants, type ButtonVariants } from '@/components/ui/button';

const props = withDefaults(
  defineProps<
    PaginationPrevProps & {
      size?: ButtonVariants['size'];
      class?: HTMLAttributes['class'];
    }
  >(),
  {
    size: 'default',
  }
);

const delegatedProps = reactiveOmit(props, 'class', 'size');
const forwarded = useForwardProps(delegatedProps);
</script>

<template>
  <PaginationPrev
    data-slot="pagination-previous"
    :class="
      cn(buttonVariants({ variant: 'ghost', size }), 'tw-gap-1 tw-px-2.5 sm:tw-pr-2.5', props.class)
    "
    v-bind="forwarded"
  >
    <slot>
      <ChevronLeftIcon />
      <span class="tw-hidden sm:tw-block">Previous</span>
    </slot>
  </PaginationPrev>
</template>
